'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Check if a number is finite
 *
 * @param param Number to be checked
 * @returns {boolean} Returns true when the `param` is a finite number
 */
exports.default = Number.isFinite || function (param) {
  return typeof param === 'number' && global.isFinite(param);
};
//# sourceMappingURL=numberIsFinite.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-utilizr/lib/numberIsFinite.js
 ** module id = 66
 ** module chunks = 0 1
 **/